import type * as api from '@gitbook/api-client';
import { confirm, toast } from '@gitbook/spine-react';
import { useEventCallback } from '@gitbook/util-react-hooks';

import { apiClient } from '../../../state';

export interface UseSetDefaultSiteVariantProps {
    organization: api.Organization;
    site: api.Site;
    siteStructure: api.SiteStructure;
}

export function useSetDefaultSiteVariant(props: UseSetDefaultSiteVariantProps) {
    const { site, organization, siteStructure } = props;
    return useEventCallback((siteSpace: api.SiteSpace) => {
        void confirm({
            title: 'Set variant as home?',
            description:
                siteStructure.type === 'sections'
                    ? 'Visitors will view this variant when they navigate to the section.'
                    : 'Visitors will view this variant when they navigate to your site from a search engine or when the type the root URL in the browser.',
            confirmLabel: 'Set as home',
            onConfirm: async (_event, { preventClose }) => {
                await toast.catch(
                    async () => {
                        if (siteSpace.section) {
                            await apiClient.siteSections.updateSiteSectionById(
                                organization.id,
                                site.id,
                                siteSpace.section,
                                {
                                    defaultSiteSpace: siteSpace.id,
                                },
                                { returnPreference: 'minimal' }
                            );
                            toast.success('Home of section updated');
                        } else {
                            await apiClient.sites.updateSiteById(organization.id, site.id, {
                                defaultSiteSpace: siteSpace.id,
                            });
                            toast.success('Home of site updated');
                        }
                    },
                    'Error while updating the home variant',
                    { onReject: preventClose }
                );
            },
        });
    });
}
